<template>
    <div class="mmy-wrapper">
        <slot name="title" />
        <div class="mmy-input">
            <loading-overlay :active.sync="displayLoader" id="loader" loader="dots" color="#1A74DB" height="30" width="100%" opacity="0.85">
                <template v-slot:after>
                    <h3 id="loading-notice"> {{ webstoreContent.selectProductsPage.getting_cables }} </h3>
                </template>
            </loading-overlay>
            <template>
                <div v-for="(row, index) in mmyData" :key="index">
                    <MmyRow :row="row" :ref="'row'+index" :makesToModels="makesToModels" :index="index" :isCableAccessoriesPage="isCableAccessoriesPage" @has-changed="hasChanged=true"/>
                </div>
                <div class="flex justify-start -mt-2" id="add-vehicle-container">
                    <v-button
                        position="left"
                        mobile="12"
                        tablet="12"
                        desktop="12"
                        styling="tertiary"
                        :disabled="false"
                        @onClickEvent="addMMYRow">
                        <template v-slot:content>
                            <span class="!underline">
                                {{ addRowText }}
                            </span>
                        </template>
                    </v-button>
                </div>
                <div v-if="!addToCart" class="flex justify-center items-center flex-wrap mt-0" id="add-vehicle-container">
                    <v-button
                        position="right"
                        mobile="12"
                        tablet="12"
                        desktop="12"
                        styling="secondary rounded"
                        :disabled="disabled"
                        @onClickEvent="submitMMYDataHandler">
                        <template v-slot:content>
                            {{ submitCablesText }}
                        </template>
                    </v-button>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import { mapGetters } from 'vuex';
    import MmyRow from './mmy-row';
    import vButton from '../utils/button';
    import CableSelectionValidations from '../../mixins/cable-selection-validation'

    export default {

        mixins: [CableSelectionValidations],

        components: {MmyRow, vButton},

        props: {
            addToCart: {
                type: Boolean,
                default: false,
            },
            isCableAccessoriesPage: {
                type: Boolean,
                default: false,
                required: false
            },
            selectedTypeOfReplacementCable: {
                required: false,
                default: 'B series'
            }
        },

        data() {
            return {
                displayLoader: false,
                makesToModels: {},
                currentCablesSelected: 0,
                hasChanged: false,
            }
        },

        computed: {
            ...mapGetters([
                'activeProductKey',
                'activeOfferKey',
            ]),

            ...mapGetters('content', [
                'webstoreContent'
            ]),

            ...mapGetters('shoppingCart', [
                'productsInCart',
            ]),

            mmyData() {
                return this.$store.getters[`${this.activeProductKey}${this.activeOfferKey}CableSelection/mmy/mmyData`];
            },

            cablesNeededCount() {
                return this.$store.getters[`${this.activeProductKey}${this.activeOfferKey}CableSelection/base/cablesNeededCount`];
            },

            cablesSelectedCount() {
                return this.$store.getters[`${this.activeProductKey}${this.activeOfferKey}CableSelection/base/cablesSelectedCount`];
            },

            addRowText() {
                return ["AG26", "AG-CBL"].includes(this.activeProductKey)  ? this.webstoreContent.cartPage.add_asset : this.webstoreContent.cartPage.add_vehicle;
            },

            totalNumberOfVehiclesInputted() {
                return this.mmyData.reduce((total, {quantity}) => total + quantity, 0)
            },

            totalCablesSubmittedData() {
                return this.$store.getters[
                    `${this.activeProductKey}${this.activeOfferKey}CableSelection/base/totalCablesSubmittedData`
                ];
            },

            totalCablesSubmittedCount() {
                let cableData = this.$store.getters[
                    `${this.activeProductKey}${this.activeOfferKey}CableSelection/base/totalCablesSubmittedData`
                ];
                let totalQuantity = 0;
                cableData && cableData.forEach(cable => {
                    totalQuantity += cable.quantity;
                });
                return totalQuantity;
            },

            submitCablesText() {
                let isOfferInCart = this.productsInCart.find(offerInCart => offerInCart.productKey === this.activeProductKey && offerInCart.offerKey === this.activeOfferKey);
                return isOfferInCart ? this.webstoreContent.selectProductsPage.update_selection : this.webstoreContent.selectProductsPage.confirm_cable_selection;
            },

            disabledClear() {
                return this.mmyData && this.mmyData.length === 1 && this.mmyData[0].make === '' && this.mmyData[0].model === '' && this.mmyData[0].year === '' && this.mmyData[0].quantity === 0
            },

            disabled() {
                if(!this.mmyData && !this.mmyData.length === 1){
                    return true;
                }
                if (this.activeProductKey === 'AG-CBL') {
                    return false
                }
                return (this.mmyData[0].make === '' || this.mmyData[0].model === '' || this.mmyData[0].year === '' || this.mmyData[0].quantity === 0) || (!this.isCableAccessoriesPage && this.cablesNeededCount === this.totalCablesSubmittedCount)
            }
        },

        methods: {
            addMMYRow() {
                return this.$store.commit(`${this.activeProductKey}${this.activeOfferKey}CableSelection/mmy/addMMYRow`);
            },

            clearVisualData() {
                this.clearSubmittedMMYData();
                this.mmyData.forEach((row, index) => {
                    this.$refs[`row${index}`] && this.$refs[`row${index}`].length > 0 && (this.$refs[`row${index}`][0].$el.classList.value = this.$refs[`row${index}`][0].$el.classList.value.replace(' error', ''));
                });
                this.setCableSelectionMessage('');
                this.$store.commit(`${this.activeProductKey}${this.activeOfferKey}CableSelection/mmy/setMMYData`, []);
                return this.addMMYRow();
            },

            setCableSelectionMessage(message) {
                return this.$store.commit(`${this.activeProductKey}${this.activeOfferKey}CableSelection/base/setCableSelectionMessage`, message);
            },

            setCableSelectionMessageType(type) {
                return this.$store.commit(`${this.activeProductKey}${this.activeOfferKey}CableSelection/base/setCableSelectionMessageType`, type);
            },

            clearSubmittedMMYData() {
                return this.$store.commit(`${this.activeProductKey}${this.activeOfferKey}CableSelection/mmy/clearSubmittedMMYData`);
            },

            submitMMYDataHandler: async function() {
                if (!this.areMMYRowsCompleted()) {
                    var t = this;
                    let badRows = this.areMMYRowsCompleteSpecific();
                    badRows.forEach(row => {
                        t.$refs[`row${row}`] && (t.$refs[`row${row}`][0].$el.classList.value = t.$refs[`row${row}`][0].$el.classList.value + ' error')
                    })
                    this.setCableSelectionMessage(this.webstoreContent.webstoreAlerts.mmy_completion_error);
                    this.setCableSelectionMessageType('general')
                    return false;
                } else {
                    this.mmyData.forEach((row, index) => {
                        this.$refs[`row${index}`] && (this.$refs[`row${index}`][0].$el.classList.value = this.$refs[`row${index}`][0].$el.classList.value.replace(' error', ''));
                    });
                }

                // Don't rerun unless we update a row
                if (!this.hasChanged) {
                    return true
                }

                this.hasChanged = false;

                if (!this.mmyData) {
                    this.clearSubmittedMMYData();
                    return true;
                }

                this.clearSubmittedMMYData();

                if (!this.isCableAccessoriesPage && this.calculateMaxCableSubmissionQuantity('mmy') > this.cablesNeededCount - this.totalCablesSubmittedCount) {
                    this.setCableSelectionMessage(this.webstoreContent.webstoreAlerts.mmy_quantity_error.replace('_cables_needed_', this.cablesNeededCount - this.totalCablesSubmittedCount).replace('_quantity_', this.calculateMaxCableSubmissionQuantity('mmy')));
                    this.setCableSelectionMessageType('general')
                    return false;
                }
                let errorCables = [];
                let outOfStockCables = [];

                try {
                    this.displayLoader = true;
                    const cablesWithIssues = await this.$store.dispatch(`${this.activeProductKey}${this.activeOfferKey}CableSelection/mmy/submitMMYData`, this.selectedTypeOfReplacementCable);
                    errorCables = cablesWithIssues.errorCables;
                    outOfStockCables = cablesWithIssues.outOfStockCables;
                    this.displayLoader = false;
                    this.setCableSelectionMessage('');
                } catch(e) {
                    this.setCableSelectionMessage(this.webstoreContent.webstoreAlerts.cable_error_retry);
                    this.setCableSelectionMessageType('general');
                    this.displayLoader = false;
                    return false;
                }

                let foundErrors = [];
                errorCables.forEach(error => {
                    let compiledName = `${error.originalPayload.make} ${error.originalPayload.model} ${error.originalPayload.year}`;
                    foundErrors.push(compiledName);
                });
                if (errorCables.length > 0 && (this.submittedMMYData.length + errorCables.length === 1)) {
                    this.setCableSelectionMessage(this.webstoreContent.webstoreAlerts.cannot_find_mmy);
                    this.setCableSelectionMessageType('general')
                } else if (errorCables.length > 0) {
                    this.setCableSelectionMessage(this.webstoreContent.webstoreAlerts.cannot_find_mmys.replace('_mmys_', foundErrors.join(', ')));
                    this.setCableSelectionMessageType('specific')
                }
                if (outOfStockCables.length > 0) {
                    const cablesSkusOufOfStock = outOfStockCables.map(cables=>cables.cable).join(', ');
                    const vehiclesUsedForOutOfStock = outOfStockCables.map(cables=>cables.customerInput.replaceAll('_',' ')).join(', ')
                     this.setCableSelectionMessage(this.webstoreContent.webstoreAlerts.out_of_stock_cables.replace('<cables>', cablesSkusOufOfStock).replace('<vins/mmys>',vehiclesUsedForOutOfStock));
                 }
            }
        },

        created() {
            if (this.$store.getters[`${this.activeProductKey}${this.activeOfferKey}CableSelection/mmy/mmyData`].length === 0) {
                this.addMMYRow();
            }
            this.unsubscribe = this.$store.subscribe((mutation) => {
                if ([`${this.activeProductKey}${this.activeOfferKey}CableSelection/base/clearTotalCablesSubmittedData`,
                    `${this.activeProductKey}${this.activeOfferKey}CableSelection/mmy/clearMMYData`
                    ].includes(mutation.type)
                ) {
                    this.clearVisualData();
                }
            });
        },

        async mounted() {
            let { data } = await axios('/webstore/make-and-models', { timeout: 20000 });
            Object.keys(data).forEach(make => data[make].sort());
            this.makesToModels = data;
		},
    }
</script>

<style scoped>

    .mmy-input {
        font-family: "Nitti Grotesk", sans-serif;
        font-style: normal;
        font-weight: normal;
    }

    @media (min-width: 736px) {
        .mmy-input {
            padding-bottom: 50px;
        }
        .mmy-wrapper {
            padding-right: 20px;
        }
    }

    .flex {
        width: 100%;
        display: flex;
    }

    #loading-notice {
        text-align: center;
    }

    #add-vehicle-container {
        padding-left: 0px;
        margin-top: 0px;
        height: 50px;
    }

    #add-vehicle-container #container {
        margin: 0;
    }

    #add-vehicle-container span {
        font-size: 17px !important;
        font-family: 'Roboto';
    }

    .flex-between {
        justify-content: space-between;
    }

    .clear {
        font-size: 20px;
        line-height: 28px;
        color: #0D6EDE;
        margin-right: 40px;
        font-weight: bold;
        cursor: pointer;
        height: fit-content;
    }

    .disabled {
        opacity: 0.4;
    }

    .error {
        background-color: white;
    }

    .error ::v-deep .v-select .vs__dropdown-toggle {
        border: 1px solid red;
        text-align: left;
    }

    .error ::v-deep .quantity-wrapper input {
        border: 1px solid red;
    }

</style>

